import React from 'react';
import config from 'config';
import makeStyles from '@material-ui/core/styles/makeStyles';
import colors from 'styles/colors';
import { transparentize } from 'polished';

import Typography from '@material-ui/core/Typography';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import HelpArticleLink from 'components/Page/HelpArticleLink';

import SourceType from 'types/Source';

const PRIMARY_INFO = [
  <strong>First Name</strong>,
  <strong>Last Name</strong>,
  <strong>Email</strong>,
];

const COMPLEMENTARY_INFO = [
  <>
    <strong>Unique Identifier</strong> (matching the unique identifier from your Primary Source)
  </>,
];

interface Props {
  isPrimary: boolean;
}

function FileUploadInfoCard({ isPrimary }: Props) {
  const classes = useStyles() as any;
  const infoBullets = isPrimary ? PRIMARY_INFO : COMPLEMENTARY_INFO;

  return (
    <div className={classes.fileDropInfoCard}>
      <div className={classes.infoCardTitle}>
        <WarningRoundedIcon className={classes.icon} />
        <Typography variant="h5">Read Before Importing</Typography>
      </div>
      <div className={classes.infoCardContent}>
        <div>
          For a successful CSV import, we <strong>require</strong> at least the following attributes
          to be included for every person. These attributes need to be in <strong>separate</strong>{' '}
          columns:
        </div>
        <ul className={classes.bullets}>
          {infoBullets.map((bullet, index) => (
            <li className={classes.listItem} key={`bullet-${index}`}>
              {bullet}
            </li>
          ))}
        </ul>
        <div className={classes.infoCardFooter}>
          Need help formatting your CSV file? Use our{' '}
          <HelpArticleLink link={config.CSV_TEMPLATE_URL} text="CSV template" />, or read our{' '}
          <HelpArticleLink
            link="https://help.justsift.com/en/articles/1835802-csv-sftp-sync-setup"
            text="formatting guide"
          />{' '}
          to reorganize your data.
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    fileDropInfoCard: {
      padding: theme.spacing(1.5),
      maxWidth: 377,
      minHeight: 267,
      border: `2px solid ${colors.warning}`,
      backgroundColor: transparentize(0.75, colors.warning),
      marginRight: theme.spacing(6.5),
      borderRadius: '4px',
    },
    infoCardTitle: {
      display: 'flex',
      marginBottom: theme.spacing(0.5),
    },
    infoCardContent: {
      fontSize: theme.typography.body2.fontSize,
      marginLeft: theme.spacing(4.125),
      marginRight: theme.spacing(),
    },
    infoCardFooter: {
      marginTop: theme.spacing(),
    },
    listItem: {
      listStyleType: 'disc !important',
    },
    icon: {
      height: 24,
      width: 24,
      fill: colors.warning,
      marginRight: theme.spacing(),
    },
    bullets: {
      paddingLeft: theme.spacing(2.5),
      margin: 0,
    },
  };
});

export default FileUploadInfoCard;
